import React from "react";
import BaseButton from "../../../../components/BaseButton";
import BaseIcon from "../../../../components/BaseIcon";
import { useTranslation } from "../../../../locales";
import "./style.scss";

export default function BlockAbout() {
  const { t } = useTranslation();

  return (
    <div className="block-about d-flex __align-center __column">
      <h1 className="h1 mb-4 text-center">
        <div>{t("Advanced study gets you to the door.")}</div>
        <div className="block-about__title-accent">{t("We get you through it.")}</div>
      </h1>
      <div className="block-about__description subtitle-1 text-neutral-darken-1 text-center">
        {t(
          "The bridge from ambition to offers. The only coaching platform dedicated to helping financial services students and universities turn academic excellence into measurable career success."
        )}
      </div>
      <div className="block-about__buttons d-flex mb-10">
        <BaseButton className="block-about__btn body-1 fw-bold pl-4 pr-3" to={"/who-we-help"} large gradient>
          {t("I'm a student")}
          <BaseIcon className="f-shrink-0 ml-2">chevron-right</BaseIcon>
        </BaseButton>
        <BaseButton
          className="block-about__btn __dark body-1 fw-bold pl-4 pr-3"
          to={"/who-we-help?universities=1"}
          large
          dark
        >
          {t("I'm a university")}
          <BaseIcon className="f-shrink-0 ml-2">chevron-right</BaseIcon>
        </BaseButton>
      </div>

      <video className="block-about__video mb-1" src="/landing/landing-video.mp4" autoPlay muted controls />
      <div className="block-about__video-description text-neutral-lighten-1 text-center">
        {t("Bridging the gap between advanced study and employability outcomes")}
      </div>
    </div>
  );
}
